import classNames from "classnames";
import { debounce } from "lodash";
import React, { useState } from "react";
import {
  ModalCloseButton,
  SettingsMobileHeader,
  TextSearchInput
} from "./../../ui-components";
import { UPLOAD_MODAL, UPLOAD_MODAL_INPUT } from "../dataHooks";
import styles from "../statics/styles/giphy-api-input-modal-scss";
import GiphySelector from "./giphySelector";
const GiphyApiInputModal = ({
  onGifAdd,
  componentData,
  helpers,
  languageDir,
  onCloseRequested,
  showCloseButton,
  t,
  getGiphyUrl,
  isMobile
}) => {
  const [searchTag, setSearchTag] = useState("");
  const triggerBi = debounce(() => {
    helpers.onPluginAction(searchTag);
  });
  const onChange = (searchTag2) => {
    setSearchTag(searchTag2);
    triggerBi();
  };
  return /* @__PURE__ */ React.createElement("div", { dir: languageDir, className: isMobile ? styles.gif_modal_mobile_container : void 0 }, isMobile && /* @__PURE__ */ React.createElement(
    SettingsMobileHeader,
    {
      onCancel: onCloseRequested,
      t,
      title: t("GIFPlugin_Mobile_Header"),
      showSaveBtn: false
    }
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(styles.giphy_api_input_modal_container, {
        [styles.mobile]: isMobile
      }),
      "data-hook": UPLOAD_MODAL
    },
    showCloseButton && /* @__PURE__ */ React.createElement("div", { className: styles.giphy_modal_header_container }, /* @__PURE__ */ React.createElement("div", null, t("Giphy_Modal_Header_Title")), /* @__PURE__ */ React.createElement(ModalCloseButton, { closeModal: onCloseRequested })),
    /* @__PURE__ */ React.createElement(
      TextSearchInput,
      {
        onClose: onCloseRequested,
        placeHolder: t("GiphyUploadModal_Search_Placeholder"),
        onChange,
        value: searchTag,
        "data-hook": UPLOAD_MODAL_INPUT
      }
    ),
    /* @__PURE__ */ React.createElement(
      GiphySelector,
      {
        searchTag,
        onCloseRequested,
        onGifAdd,
        getGiphyUrl,
        t,
        componentData
      }
    )
  ));
};
export {
  GiphyApiInputModal
};
//# sourceMappingURL=giphyApiInputModal.js.map
